import { useEffect, useState } from 'react';
import { Calendar } from 'react-date-range';
import { useSelector } from 'react-redux';

import Icon from '@components/icon/Icon';
import RadioGroup from '@components/radio-button/RadioGroup';
import { PaymentCollectionType } from '@features/group-management/constants';
import { CardProps } from '@types';

import { onceCardOptions, OnceKeys } from '../constants';

import colors from '../../../../themes/colors';

import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import './styles.css';

const OnceCard = ({
  handleActivationDate,
  handleIntervalFrequency,
  selectedDate,
  type,
  minDate,
  isImmediatePayment,
  isEdit
}: CardProps) => {
  const { currentOrg } = useSelector((state: any) => state.user);
  const [date, setDate] = useState<Date>();
  const [selectedType, setSelectedType] = useState<string>(
    isImmediatePayment ? OnceKeys?.IMMEDIATELY : OnceKeys.DUE_DATE
  );

  const handleTypeSelect = (item: string) => {
    setSelectedType(item);
    if (item === OnceKeys.IMMEDIATELY) handleActivationDate(item);
  };

  useEffect(() => {
    if (!selectedDate || type !== PaymentCollectionType.ONCE) {
      handleIntervalFrequency('');
    }
    if (
      selectedDate &&
      type === PaymentCollectionType.ONCE &&
      selectedDate !== OnceKeys.IMMEDIATELY &&
      !isImmediatePayment
    )
      setDate(new Date(selectedDate));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDate]);

  useEffect(() => {
    if (!date && isImmediatePayment) handleActivationDate(OnceKeys.IMMEDIATELY);
    else handleActivationDate(date || new Date());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date]);

  return (
    <>
      {(currentOrg?.status === 'approved' ||
        ((currentOrg?.status === 'kyc_submitted' ||
          currentOrg?.status === 'kyc_pending') &&
          currentOrg?.is_kyc_deferred === false)) && (
        <RadioGroup
          options={onceCardOptions}
          handleChange={handleTypeSelect}
          orientation="horizontal"
          selectedValue={selectedType}
          disabled={isEdit}
          labelStyle="!text-cofeeNeutral10"
        />
      )}
      {selectedType === OnceKeys.DUE_DATE ? (
        <Calendar
          className="mt-4 !text-sm !text-content"
          date={date}
          onChange={(modifiedDate) => setDate(modifiedDate)}
          color={`${colors.primary}`}
          {...(minDate && { minDate })}
        />
      ) : (
        <p className="mt-4 text-base text-cofeeNeutral10">
          Payment links will be sent to all members immediately upon group
          creation and whenever a new member is added.
        </p>
      )}
      <div className="mt-4 flex items-center gap-2 rounded-lg bg-cofeeOrange50 p-4 text-sm text-cofeeNeutral10">
        <Icon name="alert-circle" stroke={colors.warningYellow} />
        All members in this group will share the same &apos;Once&apos;
        frequency, and no further customization will be allowed for individual
        members.
      </div>
    </>
  );
};

export default OnceCard;
